import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Button } from '../../../components/Buttons';
import { Modal } from '../../../components/Modal';
import Inspector from 'react-inspector';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

const STATE = {
  showModal: false,
};

class PaymentsLogComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  onPaymentsLogBtnClick = () => {
    this.setState({ showModal: true });
  };

  onCloseModalBrnClick = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      this.invoice && (
        <>
          <Button primary onClick={this.onPaymentsLogBtnClick.bind(this)}>
            {this.props.smallBtn ? this.lbl('Log') : this.lbl('invoice.details.paymentsLogBtn')}
          </Button>
          {this.renderPaymentsLogModal()}
        </>
      )
    );
  }

  renderPaymentsLogModal() {
    if (!this.state.showModal) return null;

    return (
      <ModalComponent onClose={this.onCloseModalBrnClick.bind(this)} title={this.lbl('invoice.details.paymentsLogBtn')}>
        <HBox center vCenter>
          {this.renderModalContent()}
        </HBox>
      </ModalComponent>
    );
  }

  renderModalContent() {
    if (!this.invoice) return '';
    if (!this.invoice.entryNumber) return <p>{this.lbl('invoice.details.paymentsInvoiceNotExportedMsg')}</p>;
    let data = this.invoice.paymentsLog ? this.invoice.paymentsLog : null;
    if (!data) return <p>{this.lbl('invoice.details.paymentsNotFoundMsg')}</p>;

    return <Inspector data={data} expandLevel={2}></Inspector>;
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PaymentsLog = compose(withConnect, withRouter)(PaymentsLogComp);
